import { render } from "./mainCalendar.vue?vue&type=template&id=5ba0c4b4&scoped=true"
import script from "./mainCalendar.vue?vue&type=script&lang=js"
export * from "./mainCalendar.vue?vue&type=script&lang=js"

import "./mainCalendar.vue?vue&type=style&index=0&id=5ba0c4b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba0c4b4"]])

export default __exports__